/* HLT exact-home interactions — vanilla JS port of the original React behavior
 *
 * テーマエディタ対応:
 * カスタマイザーはセクションを選択/編集するたびに該当セクションのHTMLを
 * 再取得して差し替える(shopify:section:load)。初回のDOMContentLoadedだけで
 * 初期化していると、差し替え後はFadeInの初期スタイル(opacity:0 +
 * translateY(30px))が残って「選んだセクションがズレて消える」ように見え、
 * イベントも全て外れる。そのため初期化は init(root) に集約し、
 * shopify:section:load ごとに再実行する。二重バインドは data-hlt-bound で防ぐ。
 */
(function () {
  'use strict';

  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function bindOnce(el, key, type, handler, opts) {
    var flag = 'hltBound' + key;
    if (el.dataset && el.dataset[flag]) return;
    if (el.dataset) el.dataset[flag] = '1';
    el.addEventListener(type, handler, opts);
  }

  /* ------------------------------------------------------------------
   * 1. FadeInSection — original: IntersectionObserver, threshold 0.1,
   *    rootMargin "0px 0px -50px 0px", then opacity 1 / translateY(0)
   * ------------------------------------------------------------------ */
  var io = null;
  function reveal(el) {
    el.style.opacity = '1';
    el.style.transform = 'translateY(0)';
  }
  function initFaders(root) {
    var faders = root.querySelectorAll('[data-loc="client/src/components/FadeInSection.tsx:49"]');
    if (DESIGN_MODE || !('IntersectionObserver' in window)) {
      /* エディタ内ではアニメーション待ちにせず即表示(再描画のたびに消えるのを防ぐ) */
      faders.forEach(reveal);
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    }
    faders.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------
   * 2. Header — transparent at top, #1a1a1a after scrollY > 20
   *    (ヘッダーはセクション再描画で差し替わるため、毎回参照し直す)
   * ------------------------------------------------------------------ */
  var scrollBound = false;
  function onScroll() {
    var header = document.querySelector('header[data-loc="client/src/components/Header.tsx:875"]');
    if (!header) return;
    if (header.hasAttribute('data-force-dark') || window.scrollY > 20) {
      header.style.backgroundColor = '#1a1a1a';
    } else {
      header.style.backgroundColor = 'transparent';
    }
  }
  function initHeader() {
    if (!scrollBound) {
      scrollBound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    onScroll();
  }

  /* ------------------------------------------------------------------
   * 2b. Header buttons — Shopifyの標準機能へ接続
   *     ログイン/予約 → カスタマーアカウント、ハンバーガー → ドロワー
   * ------------------------------------------------------------------ */
  function initHeaderButtons(root) {
    /* 人型ボタンはドロップダウン開閉に使う(遷移させない) — hlt-x-header.liquid 側で制御 */
    var resvBtn = root.querySelector('button[data-loc="client/src/components/Header.tsx:183"]');
    if (resvBtn) bindOnce(resvBtn, 'Resv', 'click', function () { window.location.href = '/account'; });
    var drawer = document.getElementById('hlt-drawer');
    var menuBtn = root.querySelector('button[data-loc="client/src/components/Header.tsx:1104"]');
    if (drawer && menuBtn) {
      /* ハンバーガー=開閉トグル(開いている間はヘッダー上で✕に変形) */
      bindOnce(menuBtn, 'Menu', 'click', function () {
        var d = document.getElementById('hlt-drawer');
        if (!d) return;
        if (d.classList.contains('is-open')) {
          d.classList.remove('is-open');
          document.documentElement.classList.remove('hlt-drawer-open');
          document.querySelectorAll('.hlt-drawer-sub.is-active').forEach(function (s) { s.classList.remove('is-active'); });
        } else {
          d.classList.add('is-open');
          document.documentElement.classList.add('hlt-drawer-open');
        }
      });
      var closeDrawer = function () {
        var d = document.getElementById('hlt-drawer');
        if (d) { d.classList.remove('is-open'); document.documentElement.classList.remove('hlt-drawer-open'); }
      };
      var closeBtn = document.getElementById('hlt-drawer-close');
      var bg = document.getElementById('hlt-drawer-bg');
      if (closeBtn) bindOnce(closeBtn, 'DrawerClose', 'click', closeDrawer);
      if (bg) bindOnce(bg, 'DrawerBg', 'click', closeDrawer);
    }
  }

  /* ------------------------------------------------------------------
   * 3. Mobile category tab bar — active tab gets dark rounded style
   * ------------------------------------------------------------------ */
  function initTabs(root) {
    var tabs = root.querySelectorAll('button[data-loc="client/src/pages/Home.tsx:1476"]');
    tabs.forEach(function (tab) {
      bindOnce(tab, 'Tab', 'click', function () {
        document.querySelectorAll('button[data-loc="client/src/pages/Home.tsx:1476"]').forEach(function (t) {
          t.classList.remove('bg-[#1a1a1a]', 'rounded-t-2xl');
        });
        tab.classList.add('bg-[#1a1a1a]', 'rounded-t-2xl');
      });
    });
  }

  /* ------------------------------------------------------------------
   * 4. Destination galleries — 4 images per destination, thumbnails
   *    switch the visible image, auto-advance every 5 s (all in sync)
   *    (コンテナ→galleryのMapで管理し、再描画されたものだけ作り直す)
   * ------------------------------------------------------------------ */
  var galleryMap = typeof Map !== 'undefined' ? new Map() : null;
  var galleryTimer = null;
  function makeGallery(container) {
    var imgs = Array.prototype.filter.call(container.children, function (c) {
      return c.tagName === 'IMG';
    });
    var thumbs = container.querySelectorAll(
      'button[data-loc="client/src/pages/Home.tsx:2398"],button[data-loc="client/src/pages/Home.tsx:2505"]'
    );
    if (!imgs.length || !thumbs.length) return null;
    var desktop = thumbs[0].getAttribute('data-loc') === 'client/src/pages/Home.tsx:2505';
    var gallery = {
      index: 0,
      set: function (i) {
        this.index = ((i % imgs.length) + imgs.length) % imgs.length;
        var idx = this.index;
        imgs.forEach(function (img, j) {
          img.classList.toggle('opacity-100', j === idx);
          img.classList.toggle('opacity-0', j !== idx);
        });
        thumbs.forEach(function (btn, j) {
          var active = j === idx;
          btn.classList.toggle('ring-2', active);
          btn.classList.toggle('ring-white', active);
          btn.classList.toggle('opacity-60', !active);
          btn.classList.toggle('hover:opacity-100', !active);
          if (desktop) {
            btn.classList.toggle('border', !active);
            btn.classList.toggle('border-white/20', !active);
          }
        });
      }
    };
    thumbs.forEach(function (btn, j) {
      bindOnce(btn, 'Thumb', 'click', function () { gallery.set(j); });
    });
    gallery.set(0);
    return gallery;
  }
  function initGalleries(root) {
    if (!galleryMap) return;
    /* 切り離されたコンテナを掃除 */
    galleryMap.forEach(function (_, container) {
      if (!container.isConnected) galleryMap.delete(container);
    });
    var containers = root.querySelectorAll(
      '[data-loc="client/src/pages/Home.tsx:2347"],[data-loc="client/src/pages/Home.tsx:2460"]'
    );
    containers.forEach(function (container) {
      if (galleryMap.has(container)) return;
      var g = makeGallery(container);
      if (g) galleryMap.set(container, g);
    });
    if (galleryMap.size && !galleryTimer && !DESIGN_MODE) {
      /* エディタ内では自動回転させない(選択中のセクションが勝手に動くのを防ぐ) */
      galleryTimer = setInterval(function () {
        galleryMap.forEach(function (g, container) {
          if (container.isConnected) g.set(g.index + 1);
        });
      }, 5000);
    }
  }

  /* ------------------------------------------------------------------
   * 5. Hero search form — submit goes to Shopify search
   * ------------------------------------------------------------------ */
  function initSearch(root) {
    var searchForm = root.querySelector('form[data-loc="client/src/pages/Home.tsx:1301"]');
    if (searchForm) {
      bindOnce(searchForm, 'Search', 'submit', function (e) {
        e.preventDefault();
        var input = searchForm.querySelector('input[type="text"]');
        var q = input ? input.value.trim() : '';
        window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
      });
    }
  }

  /* ------------------------------------------------------------------
   * 6. Link rewiring — map the original SPA routes onto Shopify URLs.
   *    Tour cards (/services/<id>) use the JSON map rendered by the
   *    section settings; everything else uses fixed defaults.
   * ------------------------------------------------------------------ */
  var staticMap = {
    '/services': '/collections/services',
    '/privacy': '/pages/privacy-policy',
    '/terms': '/pages/terms-of-service',
    '/contact': '/pages/contact',
    '/chat': '/pages/contact',
    '/favorites': '/account',
    '/cart': '/cart'
  };
  function initLinks(root) {
    var productMap = {};
    var mapEl = document.getElementById('hlt-product-map');
    if (mapEl) {
      try { productMap = JSON.parse(mapEl.textContent) || {}; } catch (err) { productMap = {}; }
    }
    root.querySelectorAll('a[href]').forEach(function (a) {
      var raw = a.getAttribute('href');
      if (!raw || raw.charAt(0) === '#') return;
      /* DOMスナップショットは絶対URLを含むため、元サイトのオリジンを剥がして相対化する */
      var href = raw.replace(/^https?:\/\/(www\.)?hokkaidoluxurytrip\.com/, '');
      if (href === '') href = '/';
      if (href === raw && raw.indexOf('//') !== -1) return; /* 他ドメインの外部リンクはそのまま */
      var m = href.match(/^\/services\/(\w+)$/);
      if (m) {
        a.setAttribute('href', productMap[m[1]] || '/collections/services');
        return;
      }
      var path = href.split('#')[0];
      var hash = href.indexOf('#') !== -1 ? href.slice(href.indexOf('#')) : '';
      if (staticMap[path]) {
        a.setAttribute('href', staticMap[path] + hash);
      } else if (href !== raw) {
        a.setAttribute('href', href);
      }
    });
  }

  /* Buttons that only exist for the SPA (login, reservations, currency,
     language) are left as-is; FAQ uses native <details>/<summary>. */

  function init(root) {
    root = root || document;
    initFaders(root);
    initHeader();
    initHeaderButtons(root);
    initTabs(root);
    initGalleries(root);
    initSearch(root);
    initLinks(root);
  }

  ready(function () {
    if (DESIGN_MODE) {
      /* エディタのscrollIntoViewが固定ヘッダーの下に潜らないようにする(レイアウトには影響しない) */
      var st = document.createElement('style');
      st.textContent = '.shopify-section { scroll-margin-top: 96px; }';
      document.head.appendChild(st);
    }
    init(document);
  });

  /* カスタマイザーのセクション再描画に追随 */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
  document.addEventListener('shopify:block:select', function () {
    /* ブロック選択時も念のためFadeInを可視化 */
    if (DESIGN_MODE) initFaders(document);
  });
})();
